// src/pages/admin/ReferralsPage.jsx
import { useQuery } from '@tanstack/react-query'
import { Users } from 'lucide-react'
import { adminReferralsApi } from '../../api/services'
import { Card, CardBody, StatusBadge, PageSpinner } from '../../components/common/ui'

export default function AdminReferralsPage() {
  const { data, isLoading } = useQuery({ queryKey: ['admin-referrals'], queryFn: () => adminReferralsApi.index() })
  if (isLoading) return <PageSpinner />
  const { stats={}, referrals={} } = data?.data?.data || {}
  const list = referrals.data || []

  return (
    <div>
      <h1 className="text-xl font-display font-bold mb-6 flex items-center gap-2"><Users size={20} className="text-pink" /> Referrals</h1>
      <div className="grid grid-cols-3 gap-4 mb-6">
        {[['Total Referrals',stats.total??0],['Converted',stats.converted??0],['Rewards Issued',`₹${Number(stats.total_cash_rewards||0).toLocaleString('en-IN')}`]].map(([l,v])=>(
          <div key={l} className="bg-white border border-border rounded-xl p-4 text-center">
            <p className="text-xl font-bold text-gray-900">{v}</p>
            <p className="text-xs text-muted">{l}</p>
          </div>
        ))}
      </div>
      <div className="space-y-2">
        {list.map(r => (
          <Card key={r.id}>
            <CardBody className="flex items-center justify-between text-sm">
              <div>
                <span className="font-bold">{r.referrer?.name}</span>
                <span className="text-muted mx-2">→</span>
                <span>{r.referee?.name}</span>
                <StatusBadge status={r.status} />
              </div>
              <span className="text-xs text-muted">{new Date(r.created_at).toLocaleDateString('en-IN')}</span>
            </CardBody>
          </Card>
        ))}
        {list.length === 0 && <p className="text-center text-muted py-8">No referrals yet.</p>}
      </div>
    </div>
  )
}
